import React, { useRef, useEffect } from 'react';
import { animate } from 'animejs';
import { useLanguage } from '../context/LanguageContext';
import './Mission.css';

function Mission() {
  const { t } = useLanguage();
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        const block = section.querySelector('.mission-card');
        if (block) {
          animate(block, { opacity: [0, 1], y: [20, 0], duration: 600, ease: 'outExpo' });
        }
        observer.disconnect();
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="mission">
      <h2 id="mision-title" className="section-title">{t('mission.title')}</h2>
      <div className="mission-card">
        <div className="mission-accent" aria-hidden="true" />
        <p className="mission-text">{t('mission.text')}</p>
      </div>
    </div>
  );
}

export default Mission;
